<template>
  <div>
    <div class="section-title budget"><span>{{ getTitle('title') }}</span></div>
    <div class="section-subtitle"><i class="icon icon-grid"></i><span>{{ getTitle('subtitle') }}</span></div>
    <div>
      <b-tabs class="tabs-in-tabs">
        <b-tab>
          <template #title>
            <button class="icon-btn" @click="toggleShowObligation">
              <i class="icon icon-keyboard icon-rotate-270" v-if="showObligation"></i>
              <i class="icon icon-keyboard icon-rotate-90" v-else></i>
            </button>
            <span class="ml-2">
                {{ setText('obligation') }}
            </span>

          </template>
          <div class="top-table-line"></div>
          <c-spf-tree-table v-if="showObligation" :table-data="formObligation" :editedMonths="monthArr" :accessLevel="accessLevel" :uSumVisible="uSumVisible" :tableType="0" :createdMonths="0"/>
        </b-tab>
      </b-tabs>
    </div>
    <div>
      <b-tabs class="tabs-in-tabs">
        <b-tab>
          <template #title align="left">
            <button class="icon-btn" @click="toggleShowObligation">
              <i class="icon icon-keyboard icon-rotate-270" v-if="showPayment"></i>
              <i class="icon icon-keyboard icon-rotate-90" v-else></i>
            </button>
            <span class="ml-2">
                {{ setText('payments') }}
            </span>

          </template>
          <div class="top-table-line"></div>
          <c-spf-tree-table v-if="showPayment" :table-data="formPayment" :editedMonths="monthArr" :accessLevel="accessLevel" :uSumVisible="uSumVisible" :tableType="0" :createdMonths="0"/>
        </b-tab>
      </b-tabs>
    </div>
    <loading
        :active="loading"
        is-full-screen
        spinner="bar-fade-scale"
        color="#6495ED"
    />
  </div>

</template>

<script>

import CSpfTreeTable from "@/modules/budget/alteration/form/tabs/components/CreateForm/SpfTreeTable.vue";
import AlterationI18nMixin from "@/modules/budget/alteration/mixins/alteration-i18n-mixin";
import VueElementLoading from "vue-element-loading";

export default {
  name: 'alteration-card-out',
  components: {
      CSpfTreeTable,
      'loading': VueElementLoading
  },
  mixins: [ AlterationI18nMixin ],
  props: {

  },
  data() {
    return {
      accessLevel: {
            editAccess: false
      },
      monthArr: [],
      formObligation: [],
      formObligationPlan: [],
      formObligationFact: [],
      formPayment: [],
      formPaymentPlan: [],
      formPaymentFact: [],
      showObligation: true,
      showPayment: true,
      ost: false,
      planPayMap: new Map(),
      planOblMap: new Map(),
      currentAlteration: {},
      ds420: 0,
      oDS420: [],
      pDS420: [],
      oOst420: [],
      pOst420: [],
      oOstatki: [],
      pOstatki: [],
      loading: false,
    }
  },
  async mounted() {
    this.loading = true;
    const urlArray = location.hash.split('?')
    if (urlArray.length>0) {
      const queryString = urlArray[1];
      const urlParams = new URLSearchParams(queryString);
      const abp = urlParams.get('abp');
      const gu = urlParams.get('gu');
      const region = urlParams.get('region');
      const date = urlParams.get('date');
      const requestId = urlParams.get('requestId');
      await this.loadData(abp, gu, region, date, requestId);
    }
  },
  methods: {
    uSumVisible() {
        return 0;
    },
    getTitle(field) {
      const mainTextFieldName = "modules.budget_execution_alteration." + field;
      return this.$t(mainTextFieldName);
    },
    async loadData(abp, gu, region, date, requestId) {
      this.formObligationFact = [];
      this.formObligation = [];
      this.formPaymentFact = [];
      this.formPayment = [];
      await this.loadingArrData(abp, gu, region, date, requestId);
      if (this.formObligationFact !== undefined) {
        this.traverseAndAssign(this.formObligationFact, 0, false);
      }
      this.nameLocale(this.formObligation);

      if (this.formPaymentFact !== undefined) {
        this.traverseAndAssign(this.formPaymentFact, 1, false);
      }
      this.nameLocale(this.formPayment);
      this.loading = false;
    },
    formatDate(date) {
      const d = new Date(date);
      let month = '' + (d.getMonth() + 1);
      let day = '' + d.getDate();
      const year = d.getFullYear();

      if (month.length < 2)
        month = '0' + month;
      if (day.length < 2)
        day = '0' + day;

      return [year, month, day].join('-');
    },
    async loadingArrData (abp, gu, region, date, requestId) {
      const year = new Date(date).getFullYear();
      try {
        let resT = '';
        const params = `{"year":${year},"abp":${abp},"gu":"${gu}","region":"${region}","type":"obligation","requestId":"${requestId}","requestType":"${''}","budgetVersion":"${null}","level":"${'gu'}","date":"${this.formatDate(new Date(date))}"}`;
        resT = await fetch(
            `/api-py/get-alteration-new-data/` + params);
        const arrDate = await resT.json();
        const arrDateCopy = JSON.parse(JSON.stringify(arrDate));
        this.formObligationPlan = [];
        this.formObligationPlan = arrDateCopy?.plan;
        this.formObligationFact = [];
        this.formObligationFact = arrDateCopy?.fact;
        this.oOstatki = [];
        this.oOstatki = this.ds420 === 0
            ? arrDateCopy?.ost
            : arrDateCopy?.ostDS;
        this.oDS420 = arrDateCopy?.ostDS;
        this.oOst420 = arrDateCopy?.ost;
        this.formObligationPlan.forEach((item) => {
          this.$set(item, 'sum', item.month0 + item.month1 + item.month2 + item.month3 + item.month4 +
              item.month5 + item.month6 + item.month7 + item.month8 + item.month9 + item.month10 + item.month11);
        });
      }  catch (error) {
        this.makeToast('danger', this.setText('warning'), this.setText('errors.param') + error.toString());
        this.loading = false;
      }
      try {
        let resP = '';
        const params = `{"year":${year},"abp":${abp},"gu":"${gu}","region":"${region}","type":"payment","requestId":"${requestId}","requestType":"${''}","budgetVersion":"${null}","level":"${'gu'}","date":"${this.formatDate(new Date(date))}"}`;
        resP = await fetch(
            `/api-py/get-alteration-new-data/` + params);
        const arrDate =  await resP.json();
        const arrDateCopy = JSON.parse(JSON.stringify(arrDate));
        this.formPaymentPlan = [];
        this.formPaymentPlan = arrDateCopy?.plan;
        this.formPaymentFact = [];
        this.formPaymentFact = arrDateCopy?.fact;
        this.pOstatki = [];
        this.pOstatki = this.ds420 === 0
            ? arrDateCopy?.ost
            : arrDateCopy?.ostDS;
        this.pDS420 = arrDateCopy?.ostDS;
        this.pOst420 = arrDateCopy?.ost;
        this.formPaymentPlan.forEach((item) => {
          this.$set(item, 'sum', item.month0 + item.month1 + item.month2 + item.month3 + item.month4 +
              item.month5 + item.month6 + item.month7 + item.month8 + item.month9 + item.month10 + item.month11);
        });
      }  catch (error) {
        this.makeToast('danger', this.setText('warning'), this.setText('errors.param') + error.toString());
        this.loading = false;
      }
    },
    traverseAndAssign(items, type, newEl) {
      items.forEach(item => {
        // Присваиваем свойство
        this.combinationsArrays(item, type, newEl);

        // Рекурсивно обрабатываем детей
        if (item.child_list?.length) {
          this.traverseAndAssign(item.child_list, type, newEl);
        }
      });
    },
    combinationsArrays(item, type, newEl) {
      // Константы и начальная настройка
      const MONTHS = ['january', 'february', 'march', 'april', 'may', 'june',
        'july', 'august', 'september', 'october', 'november', 'december'];
      const zeroItem = MONTHS.reduce((acc, month) => ({...acc, [month]: 0}), {utochSum: 0});
      let objObligation = [];
      let objOPayment = [];
      let findItem = false;
      if (type >= 0) {
        for (let i = 0; i < 12; i++) {
          item['month' + i] = 0;
        }
        if (this.ost === true) {
          for (let i = 0; i < 12; i++) {
            item['month' + i] = item['month_' + i];
          }
        } else {
          for (let i = 0; i < 12; i++) {
            if (item.leftMonth < i) {
              item['month' + i] = item['month_' + i];
            } else {
              item['month' + item.leftMonth] =  Math.round((item['month' + item.leftMonth] + item['month_' + i]) *10)/10;
            }
          }
        }
      }
      if (type === 0) {
        this.formObligationPlan.forEach((itemP, index) => {
          if (item['abp'] === itemP['abp'] && item['gu'] === itemP['gu'] && item['prg'] === itemP['prg'] &&
              (item['ppr'] === itemP['ppr'] || ((item['ppr'] === null || item['ppr'] === 0) && (itemP['ppr'] === 0 || itemP['ppr'] === null))) && item['spf'] === itemP['spf'] && (!item.expense_code || item.expense_code === itemP.expense_code)) {
            objObligation = Object.assign({}, itemP, item);
            // Если в item нет child_list, удаляем его из результата
            if (!('child_list' in item)) {
              delete objObligation.child_list;
            }
            findItem = true;
          }
        });
        if (findItem) {
          this.oOstatki.forEach((itemO, index) => {
            if (item['abp'] === itemO['abp'] && item['gu'] === itemO['gu'] && item['prg'] === itemO['prg'] &&
                (item['ppr'] === itemO['ppr'] || ((item['ppr'] === 0 || item['ppr'] === null) && (itemO['ppr'] === null || itemO['ppr'] === 0))) && item['spf'] === itemO['spf']) {
              objObligation.ost = itemO.ostO;
              objObligation.ostDate = itemO.ostDate;
            }
          });
          if (!objObligation.expense_code) {
            this.formObligation.push(objObligation);
          }
        } else {
          objObligation = Object.assign(zeroItem, item);
          this.oOstatki.forEach((itemO, index) => {
            if (item['abp'] === itemO['abp'] && item['gu'] === itemO['gu'] && item['prg'] === itemO['prg'] &&
                (item['ppr'] === itemO['ppr'] || ((item['ppr'] === 0 || item['ppr'] === null) && (itemO['ppr'] === null || itemO['ppr'] === 0))) && item['spf'] === itemO['spf']) {
              objObligation.ost = itemO.ostO;
              objObligation.ostDate = itemO.ostDate;
            }
          });
          if (!objObligation.expense_code) {
            this.formObligation.push(objObligation);
          }
        }
      } else if (type > 0) {
        this.formPaymentPlan.forEach((itemP, index) => {
          if (item['abp'] === itemP['abp'] && item['gu'] === itemP['gu'] && item['prg'] === itemP['prg'] &&
              (item['ppr'] === itemP['ppr'] || ((item['ppr'] === null || item['ppr'] === 0) && (itemP['ppr'] === 0 || itemP['ppr'] === null))) && item['spf'] === itemP['spf'] && (!item.expense_code || item.expense_code === itemP.expense_code)) {
            objOPayment = Object.assign({}, itemP, item);
            if (!('child_list' in item)) {
              delete objOPayment.child_list;
            }
            findItem = true;
          }
        });
        if (findItem) {
          this.pOstatki.forEach((itemO, index) => {
            if (item['abp'] === itemO['abp'] && item['gu'] === itemO['gu'] && item['prg'] === itemO['prg'] &&
                (item['ppr'] === itemO['ppr'] || ((item['ppr'] === 0 || item['ppr'] === null) && (itemO['ppr'] === null || itemO['ppr'] === 0))) && item['spf'] === itemO['spf']) {
              objOPayment.ost = itemO.ostP;
              objOPayment.ostDate = itemO.ostDate;
            }
          });
          if (!objOPayment.expense_code) {
            this.formPayment.push(objOPayment);
          }
        } else {
          objOPayment = Object.assign(zeroItem, item);
          this.pOstatki.forEach((itemO, index) => {
            if (item['abp'] === itemO['abp'] && item['gu'] === itemO['gu'] && item['prg'] === itemO['prg'] &&
                (item['ppr'] === itemO['ppr'] || ((item['ppr'] === 0 || item['ppr'] === null) && (itemO['ppr'] === null || itemO['ppr'] === 0))) && item['spf'] === itemO['spf']) {
              objOPayment.ost = itemO.ostP;
              objOPayment.ostDate = itemO.ostDate;
            }
          });
          if (!objOPayment.expense_code) {
            this.formPayment.push(objOPayment);
          }
        }
      }
    },
    toggleShowObligation() {
      this.showObligation = !this.showObligation;
    },
  }
}
</script>

<style lang="scss" scoped>
.icon-btn{
  width: 20px;
  height: 20px;
  padding: 5px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: none !important;
  background-color: transparent;
  border: 1px solid rgba(28, 42, 62, 1);
  border-radius: 50%;
  margin: 0;
}
.icon-btn i{
  font-size: 0.4444444444rem;
  color: rgba(28, 42, 62, 1);
}
.duplicate-button{
  position: absolute;
  z-index: 2;
  top: 5px;
  right: 20px;
}
.flc_modal {
  width:100%;
  height:100%;
  &__body {
    background-color: #f7f9fc;
    border: 1px solid #d3dbe3;
    border-radius: 5px;
    margin-bottom: 23px;
  }

  &__title {
    font-weight: 600;
    font-size: 14px;
    margin-bottom: 26px;
  }

  &__item {
    display: flex;
    align-items: center;
    height: 50px;
    border: 1px solid #d3dbe3;
    justify-content: space-between;
    padding: 0px 10px 0px 16px;

    &__title {
      font-weight: 500;
      font-size: 14px;
      color: #6087a0;
    }
  }

  .input-file {
    font-weight: 600;
    font-size: 14px;
    color: #6087a0;
    &-label {
      width: 400px;
      font-weight: 600;
      font-size: 14px;
      color: #6087a0;
      cursor: pointer;
      display: flex;
      justify-self: flex-start;
    }
  }
  .form-file {
    font-weight: 600;
    font-size: 14px;
    color: #6087a0;
  }
}
</style>